import React from 'react';
import { Modal, Button, Message } from 'semantic-ui-react';

/**
 * Modal component for confirming variation deletion
 * This is a wrapper component that doesn't use Redux hooks
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Object} props.variationToDelete - The variation to delete
 * @param {Function} props.onConfirm - Function to handle deletion confirmation
 * @param {Function} props.onCancel - Function to handle cancellation
 * @returns {JSX.Element} DeleteConfirmationModalWrapper component
 */
const DeleteConfirmationModalWrapper = ({
  open,
  variationToDelete,
  onConfirm,
  onCancel
}) => {
  return (
    <Modal open={open} size="small">
      <Modal.Header>Delete Variation</Modal.Header>
      <Modal.Content>
        <p>Are you sure you want to delete this variation? This action cannot be undone.</p>
        {variationToDelete && (
          <Message warning>
            <Message.Header>You are about to delete:</Message.Header>
            <p><strong>{variationToDelete.name}</strong></p>
          </Message>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={onConfirm}>
          Delete
        </Button>
        <Button onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteConfirmationModalWrapper;
